<app-dialog-heading [heading]="heading"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="formGroup">
    <div class="clearfix">
      <!---------------------------->
      <!-- Override Indicator 1 -->
      <!---------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.overrideIndicator1"
                                  [disabled]="formGroup.get(controls.OverrideIndicator1).disabled"
                                  [formControlName]="controls.OverrideIndicator1"></app-element-slide-toggle>
      </div>
      <!---------------------------->
      <!-- Override Indicator 2 -->
      <!---------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.overrideIndicator2"
                                  [disabled]="formGroup.get(controls.OverrideIndicator2).disabled"
                                  [formControlName]="controls.OverrideIndicator2"></app-element-slide-toggle>
      </div>
      <!---------------------------->
      <!-- Override Indicator 3 -->
      <!---------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.overrideIndicator3"
                                  [disabled]="formGroup.get(controls.OverrideIndicator3).disabled"
                                  [formControlName]="controls.OverrideIndicator3"></app-element-slide-toggle>
      </div>
      <!---------------------------->
      <!-- Override Indicator 4 (Pay as Claimed Override) -->
      <!---------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.overrideIndicator4"
                                  [disabled]="formGroup.get(controls.PayAsClaimedOverride).disabled"
                                  [formControlName]="controls.PayAsClaimedOverride"></app-element-slide-toggle>
      </div>
      <!---------------------------------------------->
      <!-- (Manual Copayment Override) -->
      <!---------------------------------------------->
      <div class="override-toggle-row">
        <app-element-slide-toggle [label]="overrideIndicatorNames.manualCopaymentOverride"
                                  [disabled]="formGroup.get(controls.ManualCopaymentOverride).disabled"
                                  [formControlName]="controls.ManualCopaymentOverride"></app-element-slide-toggle>
      </div>
      @if (formGroup.get(controls.ManualCopaymentOverride).value) {
        <div class="override-toggle-row">
          <app-element-input label="Copayment Percentage"
                              type="number"
                              hint="Whole number only (e.g. 25, 30, 40)"
                              [min]="0"
                              [max]="100"
                              [step]="1"
                              [disabled]="formGroup.get(controls.ManualCopaymentPercentageOverride).disabled"
                              [formControlName]="controls.ManualCopaymentPercentageOverride"></app-element-input>
        </div>
      }

    </div>

  </form>
  <mat-dialog-actions align="center" class="dialog-button-container">
    <button class="dialog-button" mat-raised-button color="warn" (click)="onCancelDialogClick()">Cancel</button>
    <button class="dialog-button" mat-raised-button color="primary" [disabled]="formGroup.invalid" (click)="onSubmitClick($event)">Okay</button>
  </mat-dialog-actions>
</div>
